import { getAccessToken, isLoggedIn } from './session';
export class ApiService {
    constructor(serviceUrl, uiService) {
        this.serviceUrl = serviceUrl;
        this.uiService = uiService;
    }
    async post(path, data) {
        try {
            const headers = {
                'Content-Type': 'application/json'
            };
            if (isLoggedIn()) {
                headers['X-Access-Token'] = getAccessToken();
            }
            return await fetch(`${this.serviceUrl}/${path}`, {
                method: 'POST',
                headers,
                body: JSON.stringify(data)
            });
        }
        catch (err) {
            console.error(err);
            this.uiService.notifyError('Ha ocurrido un error de red.');
        }
    }
    async get(path) {
        try {
            const headers = {};
            if (isLoggedIn()) {
                headers['X-Access-Token'] = getAccessToken();
            }
            return await fetch(`${this.serviceUrl}/${path}`, {
                method: 'GET',
                headers,
            });
        }
        catch (err) {
            console.error(err);
            this.uiService.notifyError('Ha ocurrido un error de red.');
        }
    }
}
